<template>
  <div>
    <b-form-group>
      <div class="title-name mt-2 font-medium-5">{{ title }}</div>
      <label :for="`color-code-${id}`" class="w-100 color-code-picker-wrp">
        <div class="d-flex align-items-center w-100 color-pickr-custom">
          <input
            :id="`color-code-${id}`"
            :value="modelValue"
            class="ml-1 mr-2 color-code"
            required
            type="color"
            @input="onUpdate"
          />
          <div class="font-medium-5">REG {{ modelValue }}</div>
          <div class="ml-auto">
            <b-button
              id="btn-reset-color"
              class="btn-reset-color mr-3 ml-1"
              @click="onUndo"
            >
              <img
                src="~@/assets/images/icons/undo1.png"
                alt=""
                class="w-100"
              />
            </b-button>
          </div>
        </div>
      </label>
    </b-form-group>
  </div>
</template>

<script>
import { onBeforeMount, ref } from "@vue/composition-api";

export default {
  props: {
    modelValue: { type: String, default: "#000000" },
    title: { type: String, default: "" },
    id: {type: String, default: ""}
  },
  setup(props, { emit }) {
    const oldValue = ref(null);
    onBeforeMount(() => {
      if (props.modelValue) oldValue.value = props.modelValue;
    });

    const onUndo = () => {
      if (oldValue.value) emit("update:modelValue", oldValue.value);
    };

    const onUpdate = (event) => {
      emit("update:modelValue", event.target.value);
    };
    return { onUpdate, onUndo };
  },
};
</script>

<style scope>
.color-pickr-custom {
  padding: 2px 0;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #d8d6de;
  border-radius: 0.8rem;
}

#btn-reset-color.btn-reset-color {
  height: auto;
  width: 20px;
  padding: 5px 0;
  background-color: transparent !important;
  border: none;
}

#color-code {
  padding: 0;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  width: 40px;
  height: 40px;
  background-color: transparent;
  border: none;
  cursor: pointer;
}
#color-code::-webkit-color-swatch {
  border-radius: 6px;
  border: none;
}
#color-code::-moz-color-swatch {
  border-radius: 6px;
  border: none;
}

.color-code-picker-wrp {
  cursor: pointer;
}
</style>
